import React from "react";
import { Trash2, CheckCircle2, Mail, Phone } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Header, IconBtn } from "@/pages/admin/AdminBlog";

const statuses = ["new", "read", "responded", "archived"];

export default function AdminContacts() {
  const [items, setItems] = React.useState([]);
  const load = async () => setItems((await api.get("/admin/contacts")).data);
  React.useEffect(() => { load(); }, []);

  const setStatus = async (id, status_value) => {
    await api.patch(`/admin/contacts/${id}?status_value=${encodeURIComponent(status_value)}`);
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/contacts/${id}`);
    toast.success("Deleted");
    load();
  };

  const statusColor = (s) => {
    return {
      new: "bg-rose-500/10 text-rose-300 border-rose-500/20",
      read: "bg-amber-500/10 text-amber-300 border-amber-500/20",
      responded: "bg-emerald-500/10 text-emerald-300 border-emerald-500/20",
      archived: "bg-slate-500/10 text-slate-400 border-slate-500/20",
    }[s] || "bg-white/5 text-slate-300";
  };

  return (
    <div data-testid="admin-contacts">
      <Header title="Contact Submissions" />
      <div className="mt-8 space-y-4">
        {items.map((c) => (
          <div key={c.id} className="card-luxury p-6" data-testid={`contact-row-${c.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-3 flex-wrap">
                  <div className="text-white font-medium">{c.name}</div>
                  <span className={`text-xs px-2 py-0.5 rounded-full border ${statusColor(c.status)}`}>{c.status}</span>
                  <span className="text-slate-500 text-xs">{new Date(c.created_at).toLocaleString()}</span>
                </div>
                <div className="mt-1 flex flex-wrap gap-4 text-xs text-slate-400">
                  <span className="flex items-center gap-1.5"><Mail className="w-3 h-3" /> {c.email}</span>
                  {c.phone && <span className="flex items-center gap-1.5"><Phone className="w-3 h-3" /> {c.phone}</span>}
                  {c.subject && <span className="text-sky-400">{c.subject}</span>}
                </div>
                <p className="mt-3 text-slate-300 text-sm leading-relaxed max-w-3xl">{c.message}</p>
              </div>
              <div className="flex flex-col items-end gap-2">
                <select
                  value={c.status}
                  onChange={(e) => setStatus(c.id, e.target.value)}
                  className="bg-[#0B1221] border border-white/10 rounded-md px-2 py-1 text-xs text-white focus:border-sky-500 outline-none"
                  data-testid={`contact-status-${c.id}`}
                >
                  {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <div className="flex">
                  <IconBtn onClick={() => setStatus(c.id, "responded")} testId={`mark-responded-${c.id}`}><CheckCircle2 className="w-3.5 h-3.5" /></IconBtn>
                  <IconBtn onClick={() => remove(c.id)} variant="danger" testId={`delete-contact-${c.id}`}><Trash2 className="w-3.5 h-3.5" /></IconBtn>
                </div>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-slate-500 text-sm text-center py-10">No submissions yet.</div>}
      </div>
    </div>
  );
}
